import { createAction } from '@reduxjs/toolkit';

import { MODAL_TYPES } from '../modal-type/constants';
import { setModalType } from '../modal-type/slice';
import { debugMenuActions } from './slice';

export const showDebugMenu = () => setModalType(MODAL_TYPES.debugMenu);

export const debugHalt = createAction('dtmf/debugHalt');

export const { setDebugMenuStatsReport, setDrawConferenceDisabledValue, hideDebugMenu } = debugMenuActions;
